import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgUitloggen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FF7842"
      d="M29.5 7h-16v26h16z"
    />
    <path
      fill="#FFBFA5"
      fillRule="evenodd"
      d="m10.5 7 15.79-2.79v31.58L10.5 33z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="m12.16 18.98.86-1.05V8.62l-.86.13z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="m15.72 9.29.94-1.21-4.5.67v1.02zM12.16 31.25l.86-.91v-9.31l-.86-.01z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="m15.72 22.14.94-1.06-4.5-.06v1.03zM18.62 18.89l1.01-1.14V7.64l-1.01.15z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="m22.83 8.33 1.12-1.34-5.33.8V8.9zM18.62 32.21l1.01-.97V21.12l-1.01-.01z"
      clipRule="evenodd"
    />
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="m22.83 22.34 1.12-1.16-5.33-.07v1.11z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="m24.991 20.64-5-.09.018-1 5 .09z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M24.02 22.2v-3.55h1v3.55z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgUitloggen);

export default ForwardRef;
